<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<div class="modal-header">
    <h5 class="modal-title">{{ title }}</h5>
</div>

<div class="modal-body">
    <div ng-show="$ctrl.completed && !$ctrl.hideSuccessIcon">
        <i ng-show="$ctrl.error" class="is-error-indicator glyphicon glyphicon-alert"></i>
        <i ng-show="!$ctrl.error" class="is-done-indicator glyphicon glyphicon-ok"></i>
    </div>

    <div ng-show="$ctrl.completed && $ctrl.error" class="error">
        {{ error }}
    </div>
    <div ng-show="$ctrl.completed && 0 < $ctrl.messages.length">
        <div class="messages" *ngFor="let message of messages; trackBy: trackByIndex">
            <span class="message">{{ message }}</span>
        </div>
    </div>

    <div ng-show="!$ctrl.completed" us-spinner="{radius:12, width:5, length: 10}"></div>
</div>

<div
    class="modal-footer"
    ng-show="$ctrl.error || ($ctrl.completed && $ctrl.acknowledgeCompletion)"
    translate-namespace="BUSY_DIALOG"
>
    <button class="btn btn-primary" type="button" ng-click="$ctrl.dismiss()" translate=".CLOSE">Close</button>
</div>
